var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSofa2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C15.7456 4 19.0103 5.44155 20.7235 7.57532C18.886 7.93678 17.4999 9.55647 17.4999 11.5V13.5H6.49993V11.5248L6.50002 11.5064V11.5C6.50002 9.55653 5.11399 7.93678 3.27649 7.57531C4.9897 5.44155 8.25437 4 12 4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99991 11.5216L5 11.5C5 10.1193 3.88071 9 2.5 9C1.11929 9 0 10.1193 0 11.5C0 12.7592 0.930977 13.801 2.14218 13.9746C2.52768 15.3292 2.55682 16.7723 2.20979 18.1605C2.10318 18.5869 2.4257 19 2.86526 19H4.25V21C4.25 21.4142 4.58579 21.75 5 21.75C5.41421 21.75 5.75 21.4142 5.75 21V19H18.25V21C18.25 21.4142 18.5858 21.75 19 21.75C19.4142 21.75 19.75 21.4142 19.75 21V19H21.1346C21.5741 19 21.8966 18.5869 21.79 18.1605C21.443 16.7723 21.4721 15.3292 21.8576 13.9746C23.0689 13.8011 24 12.7593 24 11.5C24 10.1193 22.8807 9 21.5 9C20.1193 9 18.9999 10.1193 18.9999 11.5V14C18.9999 14.5523 18.5522 15 17.9999 15H5.99991C5.44762 15 4.99991 14.5523 4.99991 14V11.5216Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofa2);
export default __webpack_public_path__ + "static/media/sofa-2.c8283329e740f53054cb5726f25532a3.svg";
export { ForwardRef as ReactComponent };